import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Anchor, Drawer, Button, Modal, Badge } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { connect } from "react-redux";
import { act_logout } from "../../redux/actions";
import { req_add_sys_dwellTime, req_total_tqa_message } from "../../api";
import { formateDate } from "../../utils/dateUtil";
import { showRole } from "../../utils/dataUtil";
import menuList from "../../configs/menuConfig";
import { SYS_CODE } from "../../utils/contrains";
import "./index.less";

const { Link } = Anchor;
class MainHeader extends Component {
  state = {
    visible_menu: false,
    visible_logout: false,
    //mugshotUrl: "http://rm.tut.edu.tw/ab/Pic/S00305.jpg",
    currentTime: formateDate(Date.now()),
    startTime: Date.now(),
    timeElapsed: 0,
    workingTime: 30, //分鐘
    stayTime: 0,
    roleLevelName: "",
    messageTotal: 0,
  };

  api_add_dwellTime = async (item) => {
    const { token } = this.props.user;
    await req_add_sys_dwellTime(item, token);
  };

  api_total_message = async (item) => {
    const { userCode, token } = this.props.user;

    const result = await req_total_tqa_message(userCode, token);
    if (result.MessageTotal > 0) {
      this.setState({
        messageTotal: result.MessageTotal,
      });
    }
  };

  showDrawer = () => {
    this.setState({
      visible_menu: true,
    });
  };

  onMenuClose = () => {
    this.setState({
      visible_menu: false,
    });
  };

  onMenuOpen = () => {
    this.setState({
      visible_menu: true,
    });
  };

  onlyShowAuthMenus = (item) => {
    /*
      1. 當前用戶是ADMIN
      2. 如果當前item是公開的
      3. 當前用戶有此item：key有沒有在menus中
    */
    const { key, isPublic } = item;
    const menus = this.props.user.menus;
    // console.log("header-menus:",menus)
    // const userCode = this.props.user.userCode
    // console.log("header-userCode:",userCode)
    // userCode.toLowerCase() === "adminuser" ||
    if (isPublic || menus.indexOf(key) !== -1) {
      return true;
    } else if (item.children) {
      // 如果當前用戶有此item的某個子item的權限
      return !!item.children.find((child) => menus.indexOf(child.key) !== -1);
    }
    return false;
  };

  getMapMenuNodes = (menuList) => {
    return menuList.map((item) => {
      if (this.onlyShowAuthMenus(item)) {
        if (!item.children) {
          return <Link key={item.key} href={item.key} title={item.title} />;
        } else {
          return (
            <Link key={item.key} href={item.key} title={item.title}>
              {this.getMapMenuNodes(item.children)}
            </Link>
          );
        }
      } else {
        return true;
      }
    });
  };

  getReduceMenuNodes = (menuList) => {
    return menuList.reduce((item_pre, item) => {
      if (this.onlyShowAuthMenus(item)) {
        if (!item.children) {
          item_pre.push(
            <Link key={item.key} href={item.key} title={item.title} />
          );
        } else {
          item_pre.push(
            <Link key={item.key} href={item.key} title={item.title}>
              {this.getMapMenuNodes(item.children)}
            </Link>
          );
        }
      }
      return item_pre;
    }, []);
  };

  logout = () => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "確認要登出系統?",
      okText: "確認",
      cancelText: "取消",
      onOk: () => {
        clearInterval(this.intervalCountdownId);
        clearInterval(this.intervalCheckWaitId);
        this.props.act_logout();
      },
    });
  };

  //[倒數30分]計時器
  setCountdownTime = () => {
    this.intervalCountdownId = setInterval(() => {
      const currentTime = formateDate(Date.now());
      this.setState({ currentTime });

      const runTime = new Date();
      const timeElapsed = Math.floor((runTime - this.state.startTime) / 1000);
      this.setState({ timeElapsed: timeElapsed });
      //console.log("countdown", timeElapsed);
      if (this.state.timeElapsed >= this.state.workingTime * 60) {
        // 顯示[提醒用戶]已超過時間，是否需要繼續作業
        this.setCheckWaitTime();
        this.showCheckWaitModal();
      }
    }, 1000);
  };
  //[倒數10秒]計時器
  setCheckWaitTime = () => {
    //console.log("CheckWaitTime start");
    const startTime = new Date();
    this.intervalCheckWaitId = setInterval(() => {
      const runTime = new Date();
      const timeWait = Math.floor((runTime - startTime) / 1000);
      //console.log("wait", timeWait);
      // 等待10秒未回應，直接跳出
      if (timeWait >= 10) {
        //console.log("CheckWaitTime>10");
        this.checktimeConfirmModal.destroy();
        //clearInterval(this.intervalCountdownId);
        //clearInterval(this.intervalCheckWaitId);
        this.clearUser(); // 觸發componentWillUnmount
        //window.location.reload(false);
      }
    }, 1000);
  };
  // [停留時間]計時器
  setDwellTime = () => {
    this.intervalDwellId = setInterval(() => {
      let { stayTime } = this.state;
      ++stayTime;
      this.setState({ stayTime });
    }, 1000);
  };
  // 顯示[倒數10秒]警示介面
  showCheckWaitModal = () => {
    clearInterval(this.intervalCountdownId);
    this.checktimeConfirmModal = Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content:
        "您已操作30分鐘，是否要登出休息一下? 若於10秒未回應系統將自動登出",
      okText: "休息一下",
      cancelText: "繼續作業",
      onOk: () => {
        //console.log("User Click Ok");
        //clearInterval(this.intervalCheckWaitId);
        this.clearUser(); //觸發componentWillUnmount
        //this.props.history.replace("/login");
      },
      onCancel: () => {
        //console.log("User Click Cancel");
        clearInterval(this.intervalCheckWaitId);
        this.setState({ timeElapsed: 0, startTime: Date.now() }, () => {
          this.setCountdownTime();
        });
      },
    });
  };

  writeStayInfo = () => {
    // 回寫停留時間，並移除計時器
    const { userCode, userName } = this.props.user;
    const { stayTime } = this.state;
    const item = {
      DomainSystem: SYS_CODE,
      TargetPage: "首頁",
      MemberCode: userCode,
      MemberName: userName,
      StaySeconds: stayTime,
    };
    this.api_add_dwellTime(item);
    clearInterval(this.intervalDwellId);
    // console.log("停留時間(秒)：", stayTime);
  };

  clearUser = () => {
    this.props.act_logout();
  };
  ////////////////

  getTitle = () => {
    var path = this.props.location.pathname;
    if (path.indexOf("/work/business") === 0) {
      // 當前請求的是business或其子路由介面
      path = "/work/business";
    }
    if (path.indexOf("/fixcomputer/applycase") === 0) {
      // 當前請求的是applycase或其子路由介面
      path = "/fixcomputer/applycase";
    }
    if (path.indexOf("/fixcomputer/reviewcase") === 0) {
      // 當前請求的是reviewcase或其子路由介面
      path = "/fixcomputer/reviewcase";
    }
    if (path.indexOf("/fixcomputer/historyreviewcase") === 0) {
      // 當前請求的是historyreviewcase或其子路由介面
      path = "/fixcomputer/historyreviewcase";
    }
    if (path.indexOf("/fixcomputer/processcase") === 0) {
      // 當前請求的是processcase或其子路由介面
      path = "/fixcomputer/processcase";
    }
    if (path.indexOf("/learnpoints/activity") === 0) {
      // 當前請求的是activity或其子路由介面
      path = "/learnpoints/activity";
    }
    if (path.indexOf("/learnpoints/course") === 0) {
      // 當前請求的是course或其子路由介面
      path = "/learnpoints/course";
    }
    if (path.indexOf("/culturalcreativeworks/works") === 0) {
      // 當前請求的是works或其子路由介面
      path = "/culturalcreativeworks/works";
    }
    if (path.indexOf("/culturalcreativeworks/course") === 0) {
      // 當前請求的是course或其子路由介面
      path = "/culturalcreativeworks/course";
    }

    let title = "首頁";
    menuList.forEach((item) => {
      if (item.key === path) {
        title = item.title;
      } else if (item.children) {
        const citem = item.children.find((cItem) => cItem.key === path);
        if (citem) {
          title = citem.title;
        }
      }
    });
    return title;
  };

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      return this.doSomethingBeforeUnload();
    });
  };

  //////////////////////

  UNSAFE_componentWillMount() {
    this.menus = this.getReduceMenuNodes(menuList);
    const name = showRole(this.props.user.role);
    // console.log("role", this.props.user);
    this.setState({ roleLevelName: name });
  }

  componentDidMount() {
    this.setCountdownTime();
    this.setDwellTime();
    this.setupBeforeUnloadListener();
    this.api_total_message();
  }

  componentWillUnmount() {
    //console.log("componentWillUnmount");
    // [倒數15分]、[倒數10秒]計時器移除
    clearInterval(this.intervalCountdownId);
    clearInterval(this.intervalCheckWaitId);
    // [停留時間]計時器回寫數據及移除
    this.writeStayInfo();
  }

  render() {
    const { visible_menu, currentTime, roleLevelName, messageTotal } =
      this.state;
    const menus = this.menus;
    const userName = this.props.user.userName;
    const title = this.getTitle();
    return (
      <div className="main-header">
        <div className="main-header-top">
          <div className="main-header-top-item">
            {SYS_CODE === "TQA" ? (
              <>
                <Badge
                  count={messageTotal}
                  style={{ marginRight: "13px" }}
                  offset={[2, 0]}
                >
                  <a href="/home">
                    <i
                      className="fa fa-bell"
                      style={{
                        marginRight: "15px",
                        fontSize: "20px",
                        color: "#FFD133",
                      }}
                    ></i>
                  </a>
                </Badge>
                <Button
                  size="small"
                  style={{ marginRight: "2px" }}
                  danger
                  disabled
                >
                  {roleLevelName}
                </Button>
              </>
            ) : (
              ""
            )}
            <Button size="small" style={{ marginRight: "2px" }} danger>
              <i className="fas fa-user-alt"></i> {userName}，您好
            </Button>
            <Button
              type="danger"
              size="small"
              onClick={this.logout}
              style={{ marginRight: "3px" }}
            >
              {" "}
              登出 <i className="fas fa-sign-out-alt"></i>
            </Button>
            <div className="main-header-menu mobileVisible" id="top-menu">
              <Button type="primary" size="small" onClick={this.onMenuOpen}>
                <i className="fas fa-bars"></i>{" "}
              </Button>
              <Drawer
                title="功能清單"
                placement="left"
                closable={false}
                onClose={this.onMenuClose}
                visible={visible_menu}
              >
                <Anchor targetOffset="10">{menus}</Anchor>
              </Drawer>
            </div>
          </div>
        </div>
        <div className="main-header-bottom">
          <div className="header-bottom-left"> 當前頁面: {title}</div>
          <div className="header-bottom-right">
            <i className="far fa-clock"></i> <span>{currentTime}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ user: state.user }), { act_logout })(
  withRouter(MainHeader)
);
